import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  LOGALTY_STATE_CANCELED,
  LOGALTY_STATE_REFUSED,
  LOGALTY_STATE_REFUSED_INTERVENER,
} from '@app/@core/constants/logalty-digital-signature.constants';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { DetectDeviceService } from '@app/@shared/services/utils/detect-device.service';
import { DigitalSignatureServiceStore } from '@app/requests/logalty-digital-signature/digital-signature-service/digital-signature-service.store';
import { AsyncSignatureStart, ConsentExpressDTOReturn } from '@app/requests/model/logalty-signature-model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-logalty-signature-async',
  templateUrl: './logalty-signature-async.component.html',
  styleUrls: ['./logalty-signature-async.component.scss'],
})
export class LogaltySignatureAsyncComponent implements OnInit {
  public responseOK: boolean = false;
  public responseConsentsOK: boolean = false;
  public url: string = '';
  private code: string;
  data: ConsentExpressDTOReturn;

  isDocumentResultValid: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public translate: TranslateService,
    public dialog: MatDialog,
    private loaderGenericService: LoaderGenericService,
    private digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private detectDeviceService: DetectDeviceService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loaderGenericService.showSpinner();
    this.url = window.location.href;
    this.code = this.url.split('logalty-signature-async/')[1];
    this.digitalSignatureServiceStore.startAsyncSignature(this.code, this.detectDeviceService.isAccessByDevice());

    this.digitalSignatureServiceStore.startAsyncSignatureObserver().subscribe((data: AsyncSignatureStart) => {
      if (data) {
        const documentResult = data?.documentResultError?.documentResult;
        if (
          documentResult === LOGALTY_STATE_REFUSED ||
          documentResult === LOGALTY_STATE_REFUSED_INTERVENER ||
          documentResult === LOGALTY_STATE_CANCELED
        ) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '90%';
          dialogConfig.maxWidth = '450px';
          dialogConfig.data = {
            text:
              documentResult === LOGALTY_STATE_REFUSED_INTERVENER
                ? this.translate.instant('signature.dialog.refused.intervener.content')
                : this.translate.instant('signature.dialog.refused.content'),
            icon: undefined,
            title: this.translate.instant('logalty.error.firmaNoPermitida'),
            hasButtonAccept: false,
          };
          dialogConfig.disableClose = true;
          const dialog = this.dialog.open(ResponseDialogComponent, dialogConfig);
          dialog.afterClosed().subscribe(() => window.close());
        }
        this.responseOK = data.isConsentsStarting;
        this.reinitChildComponent();
        this.loaderGenericService.stopSpinner();
      }
    });

    this.digitalSignatureServiceStore.SAMLObserver().subscribe((data) => {
      if (data) {
        this.responseOK = false;
        this.responseConsentsOK = true;
        this.reinitChildComponent();
        this.loaderGenericService.stopSpinner();
      }
    });
  }

  reinitChildComponent(): void {
    this.changeDetectorRef.detectChanges();
  }
}
